import React, { useLayoutEffect, useRef, useState } from "react";
import ReactDOM from "react-dom";
import { ActiveMilestones, milestoneDate } from "./MilestonesLayer";
import styles from "./MilestonePlate.module.scss";

/** Отступ плашки от ромба и от краёв окна */
const GAP = 8;

interface MilestonePlateProps {
    active: ActiveMilestones;
}

/**
 * Подсказка над вехой при наведении: название и дата, у схлопнутых в неделю — списком.
 * Гаснет вместе с курсором и мышь пропускает; клик по вехе открывает окно правки.
 */
export const MilestonePlate: React.FC<MilestonePlateProps> = ({ active }) => {
    const rootRef = useRef<HTMLDivElement>(null);
    const [position, setPosition] = useState<React.CSSProperties>({ visibility: "hidden" });

    // над ромбом, а у верхнего края окна — под ним; по горизонтали не вылезает за экран
    useLayoutEffect(() => {
        const element = rootRef.current;

        if (!element) {
            return;
        }

        const { width, height } = element.getBoundingClientRect();
        const left = Math.max(GAP, Math.min(active.anchor.x - width / 2, window.innerWidth - width - GAP));
        const above = active.anchor.top - height - GAP;
        const top = above >= GAP ? above : active.anchor.bottom + GAP;

        setPosition({ left, top, visibility: "visible" });
    }, [active]);

    return ReactDOM.createPortal(
        <div ref={rootRef} className={styles.plate} style={position} data-milestone="true">
            {active.items.map((milestone) => (
                <div key={milestone.id} className={styles.item}>
                    <div className={styles.date}>{milestoneDate(milestone)}</div>
                    <div className={styles.name}>{milestone.name}</div>
                    {milestone.comment && <div className={styles.comment}>{milestone.comment}</div>}
                </div>
            ))}

            <div className={styles.hint}>Нажмите, чтобы открыть</div>
        </div>,
        document.body
    );
};
